export const mixPanelToken =
  process?.env?.MIXPANEL_PROJECT_TOKEN || '436afa2e6f416ea4ccdb295453566f1e';
